let blinkTimer = null;
let originalTitle = '';
let isBlinking = false;

const getDoc = () => (typeof document !== 'undefined' ? document : null);

/**
 * Bắt đầu blink tab với message
 * @param {string} message - Message hiển thị khi blink
 */
export const startTabBlink = (message = 'New message!') => {
  const documentRef = getDoc();
  if (!documentRef || isBlinking) return;

  if (!originalTitle) {
    originalTitle = documentRef.title;
  }

  isBlinking = true;
  let showMessage = false;

  blinkTimer = window.setInterval(() => {
    documentRef.title = showMessage ? originalTitle : message;
    showMessage = !showMessage;
  }, 1500);
};

/**
 * Dừng blink tab
 * @param {boolean} restoreTitle - Có restore lại title gốc không
 */
export const stopTabBlink = (restoreTitle = true) => {
  const documentRef = getDoc();

  if (blinkTimer) {
    clearInterval(blinkTimer);
    blinkTimer = null;
  }

  isBlinking = false;

  if (restoreTitle && documentRef && originalTitle) {
    documentRef.title = originalTitle;
    originalTitle = '';
  }
};

const handleVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    stopTabBlink();
  }
};

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', handleVisibilityChange);
}